<template>
  <div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <h3>店舗情報</h3>
            <div class="mt-2 mb-2">
              <div>
                店舗情報ページに表記する情報を入力してください。未入力の項目はホームページに表示されません。
              </div>
            </div>
          </v-col>
        </v-row>
        <div v-for="(item, index) in category_items" :key="index">
          <v-row>
            <v-col v-if="item.type == 'text'" cols="12" sm="4">
              <v-text-field
                v-model="item.detail"
                :name="item.category_code"
                :label="item.name"
                :success="true"
                :placeholder="item.placeholder"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col v-else-if="item.type == 'textarea'" cols="12">
              <v-textarea
                v-model="item.detail"
                :name="item.category_code"
                :label="item.name"
                :success="true"
                :placeholder="item.placeholder"
                outlined
                hide-details
                rows="3"
                auto-grow
              ></v-textarea>
            </v-col>
            <v-col v-else-if="item.type == 'html'" cols="12">
              <h3>備考</h3>
              <div class="mt-2 mb-2">
                <v-btn
                  text
                  color="primary"
                  class="font-weight-bold pa-1 d-inline"
                  @click="onHtmlClear"
                  >HTMLをクリア</v-btn
                >
                <p class="mini text-red">
                  ※GoogleMapやバナー等のHTMLを使用する際は「ソース」をクリックしてから、HTMLを貼り付け、再度「ソース」をクリックして元の画面に戻ってから保存してください。
                </p>
              </div>
              <v-card tile elevation="0" class="mb-6">
                <div class="ma-3">
                  <ckeditor-component
                    :ref="item.ref"
                    :data="item.detail"
                  ></ckeditor-component>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-4"></v-divider>
        </div>
      </v-container>
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  components: {
    imageUploaderComponent,
  },
  props: ["shop_site_id"],
  setup(props, ctx) {
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");
    const refCkeditorMemoHtml = ref(null);

    const data_id = 3; // 店舗情報 3固定
    const state = reactive({
      // 入力項目カテゴリごとのデータ構造体
      category_items: {
        open_time: {
          type: "text",
          ref: "",
          category_num: 0, // 0固定
          category_code: "open_time",
          name: "営業開始時間",
          detail: "",
          sort: 2,
          placeholder: "例) 12:00、AM10:00",
        },
        close_time: {
          type: "text",
          ref: "",
          category_num: 0, // 0固定
          category_code: "close_time",
          name: "営業終了時間",
          detail: "",
          sort: 3,
          placeholder: "例) 翌03:00、AM3:00",
        },
        reception_open_time: {
          type: "text",
          ref: "",
          category_num: 0, // 0固定
          category_code: "reception_open_time",
          name: "受付開始時間",
          detail: "",
          sort: 4,
          placeholder: "例) 09:00、AM9:00",
        },
        reception_close_time: {
          type: "text",
          ref: "",
          category_num: 0, // 0固定
          category_code: "reception_close_time",
          name: "受付終了時間",
          detail: "",
          sort: 5,
          placeholder: "例) 翌02:00、AM2:00",
        },
        tel: {
          type: "text",
          ref: "",
          category_num: 0, // 0固定
          category_code: "tel",
          name: "電話番号",
          detail: "",
          sort: 6,
          placeholder: "例) 090-1111-1111",
        },
        close_day: {
          type: "text",
          ref: "",
          category_num: 0, // 0固定
          category_code: "close_day",
          name: "定休日",
          detail: "",
          sort: 7,
          placeholder: "例) 毎週月曜日",
        },
        other: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "other",
          name: "その他補足情報等",
          detail: "",
          sort: 8,
          placeholder: "補足情報等、ご自由に入力してください",
        },
        memo_html: {
          type: "html",
          ref: "refCkeditorMemoHtml",
          category_num: 0, // 0固定
          category_code: "memo_html",
          name: "備考",
          detail: "",
          sort: 9,
        },
      },
    });

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        if (response.data.length === 0) {
          // データがない場合は何もしない
        } else {
          // 取得したデータをstateにセット
          for (const key of Object.keys(state.category_items)) {
            const item = state.category_items[key];
            const getItem = response.data.find(
              (i) => i.category_code === item.category_code
            );
            if (!getItem) continue; // 該当データがない場合はスキップ

            item.name = getItem.name || "";
            item.detail = getItem.detail || "";
          }
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    const onSubmit = async () => {
      // サイト設定保存処理
      if (!window.confirm("保存してよろしいですか？")) {
        return false;
      }

      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      for (const key of Object.keys(state.category_items)) {
        const item = state.category_items[key];
        if (item.type === "html") {
          // HTML入力処理
          item.detail = ctx.refs[item.ref][0].editorData;
        } else {
          // 特に何もしない
        }
      }

      const save_list = Object.values(state.category_items).map((item) => {
        return {
          shop_site_id: props.shop_site_id,
          data_id: data_id,
          category_num: 0,
          category_code: item.category_code,
          name: item.name,
          detail: item.detail,
          sort: item.sort,
        };
      });
      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
        save_list: save_list,
      };
      await HpListDetailRepository.save_list(params)
        .then((response) => {
          if (response.data) {
            // 保存OK
            alert("店舗情報を保存しました。");
          }
        })
        .catch((error) => {
          throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
        });

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    const onHtmlClear = () => {
      if (
        !window.confirm("HTMLに入力された内容をクリアします。よろしいですか？")
      ) {
        return;
      }
      state.category_items.memo_html.detail = "";
      ctx.refs[state.category_items.memo_html.ref][0].editorData = ""; // CKEditorの内容もクリア
    };

    // 返却オブジェクト定義
    return {
      setting,
      refCkeditorMemoHtml,
      ...toRefs(state),
      onSubmit,
      onHtmlClear,
    };
  },
});
</script>
